import React, { ComponentProps } from "react";
import { cls } from "cls";
const Skeleton = ({
  className,
  ...rest
}: ComponentProps<"span">) => <span className={cls("block bg-[#f1f1f1] rounded-sm animate-pulse", className)} {...rest} data-sentry-component="Skeleton" data-sentry-source-file="index.tsx" />;
export default Skeleton;